export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
              关于妖精视频
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                妖精视频是一个专注于水果植物系列影视内容聚合的在线平台。我们汇集了香蕉视频、蜜桃视频、西瓜视频、樱花视频、糖豆视频、樱桃视频、蘑菇视频等七个热门视频平台的最新内容，致力于为广大影视爱好者提供一站式的观影体验。
              </p>
              <p>
                平台每日自动同步各合作站点的最新更新，涵盖电影、电视剧、综艺、动漫等多种内容类型。所有视频均为高清画质，采用先进的流媒体传输技术，确保播放流畅不缓冲，让您随时随地享受极致的在线观影乐趣。
              </p>
              <p>
                无论您是想追最新热播剧集、寻找经典电影回顾，还是探索各类综艺节目，妖精视频都能为您提供便捷的发现和观看入口，是您日常娱乐消遣的最佳伴侣。
              </p>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[440px] aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20digital%20illustration%20of%20multiple%20floating%20screens%20showing%20colorful%20abstract%20video%20content%20with%20fruit%20themed%20accents%20like%20peach%20coral%20banana%20yellow%20watermelon%20green%20and%20cherry%20pink%2C%20arranged%20in%20a%20harmonious%20collage%20composition%20on%20soft%20warm%20background%2C%20minimalist%20flat%20design%20style%2C%20editorial%20quality%2C%20subtle%20gradients&width=880&height=660&seq=about-visual-02&orientation=landscape"
                alt="妖精视频多平台影视内容聚合展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}